/**
 * Shared product mockup shot used in the hero and the pricing card.
 * Replace with an updated render whenever the package changes.
 */
export const PRODUCT_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/fcm4oxQ6X4oR4e849CNvhC/hf_20260921_134800_301629a2-57a6-450a-8a5d-ed05b45db935.png'

export const PRODUCT_MOCKUP_ALT =
  'The Bootcamp Ready system: six volumes plus the 365-day calendar and bonuses shown on desktop, tablet and phone'
